import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DataService } from './data.service';
import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})

export class EventTrackingService {
  private readonly eventTrackingBaseApiUrl: string;
  private lastClickedLinkName: string | null = null;
  private renderer: Renderer2;

  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService, 
  private router: Router, private rendererFactory: RendererFactory2) {
    this.eventTrackingBaseApiUrl = `${baseUrl}api/track-event`;
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public trackEvent(eventName: string, properties: { [key: string]: any }) {

    return this.dataService.post<any>(this.eventTrackingBaseApiUrl, { eventName, properties })
    .subscribe({
      next: (resp) => {
      },
      error: (error) => {
        console.error('Error tracking navigation', error);
      },
      complete: () => {
        console.log(`Tracked Event ${eventName} ${properties} `);
      }
    });
  }

  startNavigationTracking(): void {
    /*
    // Listen to click events on the document to capture link names
    this.renderer.listen('document', 'click', (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target.tagName === 'A' && target.textContent) {
        this.lastClickedLinkName = target.textContent.trim();
      }
    });
    */
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.trackEvent('TrackEvent', 
          {'Event' : 'MenuLinkNavigation'         
          ,url: event.urlAfterRedirects
          });
      }
    });
  }
}
